import { isEmptyObject } from "utilities/common";

/** Try to parse various formats the promotion form keeps publish/expiry in (ISO with offset, "YYYY-MM-DD HH:mm:ss", Date). */
function parsePromoDate(value) {
    if (value == null || value === "") return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
    const d = new Date(value);
    if (!Number.isNaN(d.getTime())) return d;
    return null;
}

export function promoValidation(fields){
    const errors = {};
    if(!fields.name || fields.name.trim()===''){
        errors.name = 'Name is required'
    }
    // Usage Limit and Usage Limit Per User: no validation (optional fields)
    // if (fields.usageLimit === "" || fields.usageLimit == null || Number(fields.usageLimit) < 1) {
    //     errors.usageLimit = "Total usage limit is required and must be at least 1";
    // }
    // if (fields.usageLimitPerUser === "" || fields.usageLimitPerUser == null || Number(fields.usageLimitPerUser) < 1) {
    //     errors.usageLimitPerUser = "Per-user usage limit is required and must be at least 1";
    // }
    // if (fields?.code?.length === 0) {
    //   errors.code ='Atleast one promo code is required' ;
    // }
    const codes = (fields.code || [])
    .map(code => code.trim())
    .filter(Boolean); // removes empty strings
    const isAutoApply = fields?.autoApply === true;

  const descriptionLength = String(fields.description || "").trim().length;
  if (descriptionLength > 100) {
    errors.description = "Short Description must not be more than 100 characters";
  }

  if (!isAutoApply && codes.length === 0) {
    errors.code = "At least one promo code is required";
  }

  if (codes.length > 0) {
    const invalidCode = codes.find(code => code.length < 6);
    if (invalidCode) {
      errors.code = "Each promo code must be at least 6 characters long";
    }
  }

  if (fields.visibility !== "all" && fields.visibility !== "specific") {
    errors.visibility = "Please select whether this promotion is visible to All Users or Specific User(s)";
  }

  if (fields?.isExpiryDateRequired) {
    const publish = parsePromoDate(fields.publishDate);
    const expiry = parsePromoDate(fields.expiryDate);
    const nowMs = Date.now();

    if (!expiry) {
      errors.expiryDate = "Expiry date and time is required";
    } else {
      const expMs = expiry.getTime();
      if (expMs <= nowMs) {
        errors.expiryDate = "Expiry date and time must be in the future";
      } else if (publish) {
        const pubMs = publish.getTime();
        if (expMs === pubMs) {
          errors.expiryDate = "Expiry date and time cannot be the same as publish date";
        } else if (expMs < pubMs) {
          errors.expiryDate = "Expiry date must be after the publish date";
        }
      }
    }
  }

     return { errors, isValid: isEmptyObject(errors) };
}